<template>
  <div class="article-topic-block">
    <div class="article-header-banner">
      <h1 class="header-title">{{ topicData.maintitle }}</h1>
      <slot v-if="topicData.maindescription" name="description"></slot>
    </div>
    <div
      v-for="(topics, topicIndex) in topicData.maintopics"
      :key="topicIndex"
      class="topic-list-block"
    >
      <div class="sub-topic-list">
        <h2 class="topic-title" @click="redirectionToArticle(topics.url)">
          {{ topics.topicname }}
        </h2>
        <p
          v-for="(subtopic, subtopicIndex) in topics.subtopics"
          :key="subtopicIndex"
          class="subtopic-name"
        >
          <a :href="subtopic.url" class="subtopic-link">{{ subtopic.subtopictitle }}</a>
        </p>
        <a :href="topics.url" class="topic-see-all ripple-animation ripple-animation--black">{{
          topicData.filterdata
        }}</a>
      </div>
      <div class="sub-topic-list">
        <img
          v-if="topics.articles[0].image"
          :src="topics.articles[0].image.Src"
          :alt="topics.articles[0].image.Alt"
          class="recent-article-image"
          @click="redirectionToArticle(topics.articles[0].url)"
        />
        <h3 class="recent-article-title" @click="redirectionToArticle(topics.articles[0].url)">
          {{ topics.articles[0].title }}
        </h3>
        <slot :name="topics.topic_id"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'article-topic-block',
  props: {
    topicData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    redirectionToArticle(url) {
      window.location.href = url;
    },
  },
};
</script>
